/* One arrival-only audio attempt per tab visit. No sound controls or deferred replay. */
(() => {
'use strict';
if(window.GringoBrandVideo)return;
const key='gringo-brand-sound-v1',reduced=matchMedia('(prefers-reduced-motion: reduce)');
let arrivalUsed=false;
const used=()=>{try{return arrivalUsed||sessionStorage.getItem(key)==='1';}catch{return arrivalUsed||document.cookie.split(';').some(x=>x.trim()==='gringo_brand_sound=1');}};
const remember=()=>{arrivalUsed=true;try{sessionStorage.setItem(key,'1');}catch{try{document.cookie='gringo_brand_sound=1; Path=/; SameSite=Lax; Secure';}catch{}}};
function init(root){
 if(root.dataset.bound)return;root.dataset.bound='true';
 const video=root.querySelector('[data-gringo-brand-video]');
 let destroyed=false;
 const silent=()=>{
  video.muted=true;video.loop=!reduced.matches;
  if(!destroyed&&!reduced.matches&&!document.hidden)video.play().catch(()=>{});
 };
 const firstArrival=!used();
 // Consume the arrival even if autoplay is blocked. Never defer sound to a click or later page.
 if(firstArrival)remember();
 video.addEventListener('ended',silent);
 const visibility=()=>{video.muted=true;if(document.hidden)video.pause();else silent();};
 const change=()=>{video.muted=true;if(reduced.matches)video.pause();else silent();};
 document.addEventListener('visibilitychange',visibility);
 reduced.addEventListener('change',change);
 root.gringoBrandDestroy=()=>{destroyed=true;video.muted=true;video.pause();document.removeEventListener('visibilitychange',visibility);reduced.removeEventListener('change',change);};
 if(firstArrival&&!reduced.matches&&!document.hidden){
  video.muted=false;video.loop=false;video.currentTime=0;
  video.play().then(()=>{if(destroyed||document.hidden||reduced.matches){video.muted=true;video.pause();}}).catch(()=>{if(!destroyed)silent();});
 }else silent();
}
window.GringoBrandVideo={init};
document.querySelectorAll('[data-gringo-brand]').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-gringo-brand]').forEach(init));
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-gringo-brand]').forEach(root=>root.gringoBrandDestroy?.()));
})();
